import React from 'react';
import dayjs from 'dayjs';
import { Grid, Button, IconButton } from '@material-ui/core';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
} from '@material-ui/icons';
import usePrompts from '@hooks/usePrompts';
import DataTable from '@components/core/DataTable';
import PageTitle from '@components/core/PageTitle';
import popup from '@components/core/Popup';
import EditDialog from './EditDialog';

export default function Prompts() {
  const { prompts, remove, create, update } = usePrompts();

  const handleCreate = () => {
    popup({
      title: '新增 Prompt',
      content: <EditDialog onCreate={create} />,
    });
  };

  const handleEdit = (idx) => {
    popup({
      title: '編輯 Prompt',
      content: <EditDialog data={prompts[idx]} onCreate={create} onUpdate={update} />,
    });
  };

  const columns = [
    {
      name: 'index',
      label: '項次',
      options: {
        filter: false,
        customBodyRenderLite: (idx) => <>{idx + 1}</>,
      },
    },
    {
      name: 'name',
      label: '名稱',
      options: { filter: false },
    },
    {
      name: 'content',
      label: '內容',
      options: {
        filter: false,
        customBodyRender: (content) =>
          content?.length > 50 ? content.slice(0, 50) + '...' : content,
      },
    },
    {
      name: 'created_at',
      label: '建立時間',
      options: {
        filter: false,
        customBodyRender: (v) =>
          v ? dayjs.unix(v).format('YYYY-MM-DD HH:mm:ss') : '',
      },
    },
    {
      name: 'id',
      label: '操作',
      options: {
        filter: false,
        customBodyRenderLite: (idx) => (
          <>
            <IconButton onClick={() => handleEdit(idx)}>
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => remove(prompts[idx].id)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </>
        ),
      },
    },
  ];

  return (
    <>
      <PageTitle
        title="常用 Prompt"
        extra={
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleCreate}
          >
            新增 Prompt
          </Button>
        }
      />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <DataTable
            data={prompts}
            columns={columns}
            options={{ elevation: 0 }}
          />
        </Grid>
      </Grid>
    </>
  );
}
